var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57046_74592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.53277 27.7195H7.6707V15.263L0.322266 9.79651V25.5389C0.322266 26.7338 1.30803 27.7195 2.53277 27.7195Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2354 27.7195H30.3733C31.598 27.7195 32.5838 26.7338 32.5838 25.509V9.79651L25.2652 15.2929V27.7195H25.2354Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2354 5.76384V15.2929L32.5539 9.79652V6.86909C32.5539 4.15077 29.4473 2.59744 27.2666 4.24039L25.2354 5.76384Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64062 15.263V5.76379L16.4229 12.3654L25.2052 5.76379V15.2929L16.4528 21.8646L7.64062 15.263Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.322266 6.83921V9.76663L7.64083 15.263V5.76382L5.57968 4.2105C3.42892 2.59743 0.322266 4.15075 0.322266 6.83921Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57046_74592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5 0.00012207)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.94da639fcb351872e4369dd39e11ce1a.svg";
export { ForwardRef as ReactComponent };